import React from 'react';
import './Divider.scss';

export const Divider = () => {
    return <div className="section-divider section-p d-flex justify-content-center">
        <div className="divider"></div>
    </div>;
};